<template>
    <div class="page">
        <!-- 搜索 -->
        <el-form v-if="isSearch" :model="queryForm" ref="form" label-width="80px" :inline="true" size="small"
                 class="query-form" @submit.native.prevent>
            <el-form-item label="订单名称">
                <el-input v-model="queryForm.orderName"></el-input>
            </el-form-item>
            <el-form-item label="订单类型">
                <el-input v-model="queryForm.orderType"></el-input>
            </el-form-item>
            <el-form-item label="优质采唯一订单编号">
                <el-input v-model="queryForm.orderCode"></el-input>
            </el-form-item>
            <el-form-item label="订单状态">
                <el-input v-model="queryForm.orderStatus"></el-input>
            </el-form-item>
            <el-form-item label="一级地址id">
                <el-input v-model="queryForm.provinceId"></el-input>
            </el-form-item>
            <el-form-item label="二级地址id">
                <el-input v-model="queryForm.cityId"></el-input>
            </el-form-item>
            <el-form-item label="三级地址id">
                <el-input v-model="queryForm.countyId"></el-input>
            </el-form-item>
            <el-form-item label="四级地址id">
                <el-input v-model="queryForm.townId"></el-input>
            </el-form-item>
            <el-form-item label="收货详细地址">
                <el-input v-model="queryForm.deliveryAddr"></el-input>
            </el-form-item>
            <el-form-item label="收货人名称">
                <el-input v-model="queryForm.contacts"></el-input>
            </el-form-item>
            <el-form-item label="下单人">
                <el-input v-model="queryForm.oprName"></el-input>
            </el-form-item>
            <el-form-item label="下单人联系方式">
                <el-input v-model="queryForm.oprTel"></el-input>
            </el-form-item>
            <el-form-item label="收货人联系电话">
                <el-input v-model="queryForm.contactTel"></el-input>
            </el-form-item>
            <el-form-item label="订单总金额">
                <el-input v-model="queryForm.orderTotalPrice"></el-input>
            </el-form-item>
            <el-form-item label="订单创建时间">
                <el-input v-model="queryForm.oprDate"></el-input>
            </el-form-item>
            <el-form-item label="订单创建单位">
                <el-input v-model="queryForm.companyName"></el-input>
            </el-form-item>
            <el-form-item label="订单需求单位名称">
                <el-input v-model="queryForm.purchaseCompanyName"></el-input>
            </el-form-item>
            <el-form-item label="订单备注">
                <el-input v-model="queryForm.remark"></el-input>
            </el-form-item>
            <el-form-item>
                <el-button size="small" type="primary" icon="el-icon-search" @click="getYouzhicaiOrderList">查询
                </el-button>
                <el-button size="small" icon="el-icon-refresh" @click="resetDialog">重置</el-button>
            </el-form-item>
        </el-form>
        <div class="page-content">
            <div class="page-tool-bar">
                <div class="el-btn-group">
<!--                    <el-button-->
<!--                        type="primary"-->
<!--                        size="small"-->
<!--                        icon="el-icon-plus"-->
<!--                        @click="addYouzhicaiOrder"-->
<!--                    >新建-->
<!--                    </el-button>-->
<!--                    <el-button-->
<!--                        type="warning"-->
<!--                        plain-->
<!--                        size="small"-->
<!--                        icon="el-icon-edit"-->
<!--                        :disabled="multipleSelection.length != 1"-->
<!--                        @click="editYouzhicaiOrder(null)"-->
<!--                    >修改-->
<!--                    </el-button>-->
                    <el-button
                        type="danger"
                        plain
                        size="small"
                        icon="el-icon-delete"
                        :disabled="multipleSelection.length <= 0"
                        @click="deleteYouzhicaiOrder(null)"
                    >删除
                    </el-button>
                </div>

                <div class="icon-group">
                    <el-upload v-if="this.isImportDate"
                               class="upload-demo"
                               action="#"
                               :http-request="upload"
                               :show-file-list="true">
                        <el-button size="small" type="primary">点击上传</el-button>
                        <div slot="tip" class="el-upload__tip">只允许导入“xls”或“xlsx”格式文件！</div>
                    </el-upload>
                    <span
                        title="搜索"
                        class="icon-box"
                        @click="search"
                    >
                      <Icon color="#606266">
                        <Search />
                      </Icon>
                    </span>
                    <span
                        title="下载模板"
                        class="icon-box"
                        @click="importTemplate"
                    >
                      <Icon color="#606266">
                        <ArrowDown />
                      </Icon>
                    </span>
                    <span
                        class="icon-box"
                        title="导入数据"
                        @click="isImport"
                    >
                      <Icon color="#606266">
                        <ArrowExportUp24Regular />
                      </Icon>
                    </span>
                    <span
                        title="导出数据"
                        class="icon-box"
                        @click="exportYouzhicaiOrderList"
                    >
                      <Icon color="#606266">
                        <ArrowDownload24Regular />
                      </Icon>
                    </span>
                    <span
                        class="icon-box"
                        @click="refreshYouzhicaiOrderList"
                    >
                      <Icon color="#606266">
                        <Refresh />
                      </Icon>
                    </span>
                </div>
            </div>
            <!-- 列表数据 -->
            <el-table
                :data="youzhicaiOrderList"
                row-key="id"
                height="100%"
                :header-row-style="{height: '10px'}"
                :header-cell-style="{padding: '10px'}"
                :row-style="{height: '9px'}"
                :cell-style="{padding: '9px'}"
                @selection-change="handleSelectionChange"
                size="small"
            >
                <el-table-column
                    align="center"
                    type="selection"
                    width="60"
                ></el-table-column>
                <el-table-column
                    :show-overflow-tooltip="true"
                    align="center"
                    label="商品信息"
                    width="600"
                >
                    <template scope="scope">
                        <div>
                            <el-table
                                :header-cell-style="{ textAlign: 'center' }"
                                :cell-style="{ textAlign: 'center' }"
                                :show-header="false"
                                :data="scope.row.products"
                                row-key="id"
                                size="small"
                                style="margin-top: 0"
                                height="100%"
                            >
                                <el-table-column :show-overflow-tooltip="true" align="center" label="商品图片" width="100">
                                    <template slot-scope="scope">
                                        <el-image
                                            @click='updateSrcList(scope.row.product.imagePath)'
                                            style="width: 30px; height: 30px"
                                            :src="scope.row.product.imagePath"
                                            :preview-src-list="srcList"
                                        > </el-image>
                                    </template>
                                </el-table-column>
                                <el-table-column
                                    :show-overflow-tooltip="true"
                                    align="left"
                                    prop="product.goodsName"
                                    label="商品名称"
                                    width="200"
                                >
                                </el-table-column>
                                <el-table-column
                                    :show-overflow-tooltip="true"
                                    align="left"
                                    prop="productPrice"
                                    label="商品单价"
                                >
                                    <template scope="scope">
                                        <span>￥{{ scope.row.productPrice }}</span>
                                    </template>
                                </el-table-column>
                                <el-table-column
                                    :show-overflow-tooltip="true"
                                    align="left"
                                    prop="productNum"
                                    label="商品数量"
                                >
                                    <template scope="scope">
                                        <span>{{ scope.row.productNum+scope.row.product.unit }}</span>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column
                    :show-overflow-tooltip="true"
                    align="center"
                    prop="orderTotalPrice"
                    label="订单总金额"
                    width="180"
                >
                    <template scope="scope">
                        <span>￥{{ scope.row.orderTotalPrice }}</span>
                    </template>
                </el-table-column>
                <el-table-column
                    :show-overflow-tooltip="true"
                    align="center"
                    prop="orderName"
                    label="订单名称"
                    width="180"
                >
                    <template scope="scope">
                        <span v-if="scope.row.orderName">{{ scope.row.orderName }}</span>
                        <span v-else>-</span>
                    </template>
                </el-table-column>
                <el-table-column
                    :show-overflow-tooltip="true"
                    align="center"
                    prop="orderStatus"
                    label="订单状态"
                    width="180"
                >
                    <template scope="scope">
                        <el-button type="primary" size="small" plain v-if="scope.row.orderStatus == 1"><span>{{ computeOrderStatus(scope.row.orderStatus) }}</span></el-button>
                        <el-button type="warning" size="small" plain v-if="scope.row.orderStatus == 2"><span>{{ computeOrderStatus(scope.row.orderStatus) }}</span></el-button>
                        <el-button type="warning" size="small" plain v-if="scope.row.orderStatus == 3"><span>{{ computeOrderStatus(scope.row.orderStatus) }}</span></el-button>
                        <el-button type="success" size="small" plain v-if="scope.row.orderStatus == 4"><span>{{ computeOrderStatus(scope.row.orderStatus) }}</span></el-button>
                        <el-button type="info" size="small" plain v-if="scope.row.orderStatus == 5"><span>{{ computeOrderStatus(scope.row.orderStatus) }}</span></el-button>
                    </template>
                </el-table-column>
                <el-table-column
                    :show-overflow-tooltip="true"
                    align="center"
                    prop="orderType"
                    label="订单类型"
                    width="180"
                >
                    <template scope="scope">
                        <span v-if="scope.row.orderType">{{ scope.row.orderType }}</span>
                        <span v-else>-</span>
                    </template>
                </el-table-column>
                <el-table-column
                    :show-overflow-tooltip="true"
                    align="center"
                    prop="orderCode"
                    label="优质采唯一订单编号"
                    width="180"
                >
                    <template scope="scope">
                        <span v-if="scope.row.orderCode">{{ scope.row.orderCode }}</span>
                        <span v-else>-</span>
                    </template>
                </el-table-column>
<!--                <el-table-column-->
<!--                    :show-overflow-tooltip="true"-->
<!--                    align="center"-->
<!--                    prop="provinceId"-->
<!--                    label="一级地址id"-->
<!--                    width="180"-->
<!--                >-->
<!--                    <template scope="scope">-->
<!--                        <span>{{ scope.row.area.provinceName }}</span>-->
<!--                    </template>-->
<!--                </el-table-column>-->
<!--                <el-table-column-->
<!--                    :show-overflow-tooltip="true"-->
<!--                    align="center"-->
<!--                    prop="cityId"-->
<!--                    label="二级地址id"-->
<!--                    width="180"-->
<!--                >-->
<!--                    <template scope="scope">-->
<!--                        <span>{{ scope.row.area.cityName }}</span>-->
<!--                    </template>-->
<!--                </el-table-column>-->
<!--                <el-table-column-->
<!--                    :show-overflow-tooltip="true"-->
<!--                    align="center"-->
<!--                    prop="countyId"-->
<!--                    label="三级地址id"-->
<!--                    width="180"-->
<!--                >-->
<!--                    <template scope="scope">-->
<!--                        <span>{{ scope.row.area.countyName }}</span>-->
<!--                    </template>-->
<!--                </el-table-column>-->
<!--                <el-table-column-->
<!--                    :show-overflow-tooltip="true"-->
<!--                    align="center"-->
<!--                    prop="townId"-->
<!--                    label="四级地址id"-->
<!--                    width="180"-->
<!--                >-->
<!--                    <template scope="scope">-->
<!--                        <span>{{ scope.row.area.townName }}</span>-->
<!--                    </template>-->
<!--                </el-table-column>-->
                <el-table-column
                    :show-overflow-tooltip="true"
                    align="center"
                    prop="deliveryAddr"
                    label="收货地址"
                    width="280"
                >
                    <template scope="scope">
                        <div>{{ scope.row.area.provinceName +  scope.row.area.cityName + scope.row.area.countyName + scope.row.area.townName + scope.row.deliveryAddr }}</div>

                    </template>
                </el-table-column>
                <el-table-column
                    :show-overflow-tooltip="true"
                    align="center"
                    prop="contacts"
                    label="收货人名称"
                    width="180"
                >
                    <template scope="scope">
                        <span v-if="scope.row.contacts">{{ scope.row.contacts }}</span>
                        <span v-else>-</span>
                    </template>
                </el-table-column>
                <el-table-column
                    :show-overflow-tooltip="true"
                    align="center"
                    prop="oprName"
                    label="下单人"
                    width="180"
                >
                    <template scope="scope">
                        <span v-if="scope.row.oprName">{{ scope.row.oprName }}</span>
                        <span v-else>-</span>
                    </template>
                </el-table-column>
                <el-table-column
                    :show-overflow-tooltip="true"
                    align="center"
                    prop="oprTel"
                    label="下单人联系方式"
                    width="180"
                >
                    <template scope="scope">
                        <span v-if="scope.row.oprTel">{{ scope.row.oprTel }}</span>
                        <span v-else>-</span>
                    </template>
                </el-table-column>
                <el-table-column
                    :show-overflow-tooltip="true"
                    align="center"
                    prop="contactTel"
                    label="收货人联系电话"
                    width="180"
                >
                    <template scope="scope">
                        <span v-if="scope.row.contactTel">{{ scope.row.contactTel }}</span>
                        <span v-else>-</span>
                    </template>
                </el-table-column>
                <el-table-column
                    :show-overflow-tooltip="true"
                    align="center"
                    prop="oprDate"
                    label="订单创建时间"
                    width="180"
                >
                    <template scope="scope">
                        <span v-if="scope.row.oprDate">{{ scope.row.oprDate }}</span>
                        <span v-else>-</span>
                    </template>
                </el-table-column>
                <el-table-column
                    :show-overflow-tooltip="true"
                    align="center"
                    prop="companyName"
                    label="订单创建单位"
                    width="180"
                >
                    <template scope="scope">
                        <span v-if="scope.row.companyName">{{ scope.row.companyName }}</span>
                        <span v-else>-</span>
                    </template>
                </el-table-column>
                <el-table-column
                    :show-overflow-tooltip="true"
                    align="center"
                    prop="purchaseCompanyName"
                    label="订单需求单位名称"
                    width="180"
                >
                    <template scope="scope">
                        <span v-if="scope.row.purchaseCompanyName">{{ scope.row.purchaseCompanyName }}</span>
                        <span v-else>-</span>
                    </template>
                </el-table-column>
                <el-table-column
                    :show-overflow-tooltip="true"
                    align="center"
                    prop="remark"
                    label="订单备注"
                    width="180"
                >
                    <template scope="scope">
                        <span v-if="scope.row.remark">{{ scope.row.remark }}</span>
                        <span v-else>-</span>
                    </template>
                </el-table-column>
                <el-table-column
                    fixed="right"
                    align="center"
                    label="操作"
                    width="300"
                >
                    <template slot-scope="scop">
                        <div class="operation">
                            <div @click="delivery(scop.row.id)" v-if="scop.row.orderStatus == 2">
                                <Icon size="16">
                                    <Edit24Regular />
                                </Icon>
                                <span class="operation-label">发货</span>
                            </div>
                            <div @click="freight(scop.row.id)" v-if="scop.row.orderStatus == 3 && scop.row.isPartOrder == 0 && scop.row.freights.length == 0">
                                <Icon size="16">
                                    <Edit24Regular />
                                </Icon>
                                <span class="operation-label">更新物流信息</span>
                            </div>
                            <div @click="getLogistics(scop.row.id)" v-if="scop.row.orderStatus == 3 && scop.row.freights.length > 0">
                                <Icon size="16">
                                    <Edit24Regular />
                                </Icon>
                                <span class="operation-label">查看物流信息</span>
                            </div>
                            <div @click="orderDlok(scop.row.id)" v-if="scop.row.orderStatus == 3 && scop.row.freights.length > 0">
                                <Icon size="16">
                                    <Edit24Regular />
                                </Icon>
                                <span class="operation-label">妥投</span>
                            </div>
<!--                            <div @click="checkYouzhicaiOrder(scop.row.id)">-->
<!--                                <Icon size="16">-->
<!--                                    <Eye24Regular />-->
<!--                                </Icon>-->
<!--                                <span class="operation-label">查看</span>-->
<!--                            </div>-->
<!--                            <div @click="editYouzhicaiOrder(scop.row.id)">-->
<!--                                <Icon size="16">-->
<!--                                    <Edit24Regular />-->
<!--                                </Icon>-->
<!--                                <span class="operation-label">修改</span>-->
<!--                            </div>-->
<!--                            <div @click="deleteYouzhicaiOrder(scop.row.id)">-->
<!--                                <Icon size="16" style="color: red">-->
<!--                                    <Delete24Regular />-->
<!--                                </Icon>-->
<!--                                <span class="operation-label" style="color: red">删除</span>-->
<!--                            </div>-->
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination-box">
                <el-pagination
                    @size-change="sizeChange"
                    @current-change="currentChange"
                    :current-page.sync="currentPage"
                    :page-sizes="[10, 20, 50, 100]"
                    :page-size="pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="totalNum"
                    background
                    :pager-count="7"
                >
                </el-pagination>
            </div>
            <!-- 发货 -->
            <order-delivery
                :showDialog="deliveryDialog"
                :youzhicaiOrder="youzhicaiOrder"
                @closeDeliveryDialog="closeDeliveryDialog()"
                @resetDialog="resetDialog()"
                @resetYouzhicaiOrderList="resetYouzhicaiOrderList()"
            ></order-delivery>
            <!--物流-->
            <order-freight
                ref="orderFreight"
                :showDialog="freightDialog"
                :youzhicaiOrder="youzhicaiOrder"
                @closeFreightDialog="closeFreightDialog()"
                @resetDialog="resetDialog()"
                @resetYouzhicaiOrderList="resetYouzhicaiOrderList()"
            ></order-freight>
        </div>
    </div>
</template>

<script>
import { ArrowDownload24Regular, ArrowExportUp24Regular } from '@v2icons/fluent';
import { GridDots, Refresh, Printer, ArrowUp, ArrowDown, Search } from '@v2icons/tabler';
import { Edit24Regular, Delete24Regular, Eye24Regular } from '@v2icons/fluent';
import { exprotExcel, importTemplate, importDate, get, post, put, deleteFun } from '@/utils/request.js';
import OrderDelivery from '@/components/youzhicai/orderDelivery.vue';
import OrderFreight from '@/components/youzhicai/orderFreight.vue';

export default {
    components: {
        Edit24Regular,
        Delete24Regular,
        Eye24Regular,
        GridDots,
        Refresh,
        Printer,
        ArrowUp,
        ArrowDown,
        ArrowDownload24Regular,
        ArrowExportUp24Regular,
        Search,
        OrderDelivery,
        OrderFreight
    },
    watch: {
        checkState(val) {
            if (val == 'check') {
                this.resetYouzhicaiOrderList();
                this.getYouzhicaiOrderList(this.queryForm);
                this.$emit('resetCheckState');
            } else if (val == 'reset') {
                this.resetYouzhicaiOrderList();
                this.getYouzhicaiOrderList();
                this.$emit('resetCheckState');
            }
        }
    },
    data() {
        return {
            orderStatusEnumList: [], //获取优质采订单状态枚举
            srcList: [''],//大图预览

            queryForm: {
                orderName: '', //订单名称
                orderType: '', //订单类型
                orderCode: '', //优质采唯一订单编号
                orderStatus: '', //订单状态
                provinceId: '', //一级地址id
                cityId: '', //二级地址id
                countyId: '', //三级地址id
                townId: '', //四级地址id
                deliveryAddr: '', //收货详细地址
                contacts: '', //收货人名称
                oprName: '', //下单人
                oprTel: '', //下单人联系方式
                contactTel: '', //收货人联系电话
                orderTotalPrice: '', //订单总金额
                oprDate: '', //订单创建时间
                companyName: '', //订单创建单位
                purchaseCompanyName: '', //订单需求单位名称
                remark: '', //订单备注
            },
            loading: false,
            showDialog: false,
            deliveryDialog: false,
            freightDialog: false,
            isImportDate: false,
            isSearch: false,
            pageSize: 10,
            currentPage: 1,
            totalNum: 0,
            currentUserId: '',
            youzhicaiOrderState: 'add',
            youzhicaiOrderStates: {
                add: '新建youzhicai_order',
                check: '查看youzhicai_order',
                edit: '修改youzhicai_order'
            },

            multipleSelection: [],
            youzhicaiOrderList: [],
            youzhicaiOrder: {
                orderName: '', //订单名称
                orderType: '', //订单类型
                orderCode: '', //优质采唯一订单编号
                orderStatus: '', //订单状态
                provinceId: '', //一级地址id
                cityId: '', //二级地址id
                countyId: '', //三级地址id
                townId: '', //四级地址id
                deliveryAddr: '', //收货详细地址
                contacts: '', //收货人名称
                oprName: '', //下单人
                oprTel: '', //下单人联系方式
                contactTel: '', //收货人联系电话
                orderTotalPrice: '', //订单总金额
                oprDate: '', //订单创建时间
                companyName: '', //订单创建单位
                purchaseCompanyName: '', //订单需求单位名称
                remark: '', //订单备注
            },
            btnLoading: false,

            rules: {
                orderName: [{ required: true, message: '订单名称不能为空', trigger: 'blur' }],
                orderType: [{ required: true, message: '订单类型不能为空', trigger: 'blur' }],
                orderCode: [{ required: true, message: '优质采唯一订单编号不能为空', trigger: 'blur' }],
                orderStatus: [{ required: true, message: '订单状态不能为空', trigger: 'blur' }],
                provinceId: [{ required: true, message: '一级地址id不能为空', trigger: 'blur' }],
                cityId: [{ required: true, message: '二级地址id不能为空', trigger: 'blur' }],
                countyId: [{ required: true, message: '三级地址id不能为空', trigger: 'blur' }],
                townId: [{ required: true, message: '四级地址id不能为空', trigger: 'blur' }],
                deliveryAddr: [{ required: true, message: '收货详细地址不能为空', trigger: 'blur' }],
                contacts: [{ required: true, message: '收货人名称不能为空', trigger: 'blur' }],
                oprName: [{ required: true, message: '下单人不能为空', trigger: 'blur' }],
                oprTel: [{ required: true, message: '下单人联系方式不能为空', trigger: 'blur' }],
                contactTel: [{ required: true, message: '收货人联系电话不能为空', trigger: 'blur' }],
                orderTotalPrice: [{ required: true, message: '订单总金额不能为空', trigger: 'blur' }],
                oprDate: [{ required: true, message: '订单创建时间不能为空', trigger: 'blur' }],
                companyName: [{ required: true, message: '订单创建单位不能为空', trigger: 'blur' }],
                purchaseCompanyName: [{ required: true, message: '订单需求单位名称不能为空', trigger: 'blur' }],
                remark: [{ required: true, message: '订单备注不能为空', trigger: 'blur' }]
            }
        };
    },
    created() {
        this.getYouzhicaiOrderList();
        this.getOrderStatusEnum();
    },
    methods: {
        search() {
            this.isSearch = !this.isSearch;
        },
        resetYouzhicaiOrderList() {
            this.pageSize = 10;
            this.currentPage = 1;
            this.youzhicaiOrderList = [];
        },
        resetDialog() {
            this.youzhicaiOrderState = 'add';
            this.showDialog = false;
            this.queryForm = {
                orderName: '', //订单名称
                orderType: '', //订单类型
                orderCode: '', //优质采唯一订单编号
                orderStatus: '', //订单状态
                provinceId: '', //一级地址id
                cityId: '', //二级地址id
                countyId: '', //三级地址id
                townId: '', //四级地址id
                deliveryAddr: '', //收货详细地址
                contacts: '', //收货人名称
                oprName: '', //下单人
                oprTel: '', //下单人联系方式
                contactTel: '', //收货人联系电话
                orderTotalPrice: '', //订单总金额
                oprDate: '', //订单创建时间
                companyName: '', //订单创建单位
                purchaseCompanyName: '', //订单需求单位名称
                remark: ''
            };
            this.getYouzhicaiOrderList();
        },
        closeDialog() {
            this.showDialog = false;
            this.youzhicaiOrder = {
                orderName: '', //订单名称
                orderType: '', //订单类型
                orderCode: '', //优质采唯一订单编号
                orderStatus: '', //订单状态
                provinceId: '', //一级地址id
                cityId: '', //二级地址id
                countyId: '', //三级地址id
                townId: '', //四级地址id
                deliveryAddr: '', //收货详细地址
                contacts: '', //收货人名称
                oprName: '', //下单人
                oprTel: '', //下单人联系方式
                contactTel: '', //收货人联系电话
                orderTotalPrice: '', //订单总金额
                oprDate: '', //订单创建时间
                companyName: '', //订单创建单位
                purchaseCompanyName: '', //订单需求单位名称
                remark: ''
            };
        },
        closeDeliveryDialog(){
            this.deliveryDialog = false
            this.closeDialog
        },
        closeFreightDialog(){
            this.freightDialog = false
            this.closeDialog
        },
        submitForm() {
            if (this.youzhicaiOrderState == 'add') {
                this.$refs.youzhicaiOrderForm.validate((valid) => {
                    if (valid) {
                        console.log('submit');
                        post(`/youzhicai/order/add`, { ...this.youzhicaiOrder }).then((res) => {
                            if (res.success) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000
                                });
                                this.resetYouzhicaiOrderList();
                                this.resetDialog();
                            } else {
                                this.$message({
                                    message: res.msg,
                                    type: 'error',
                                    duration: 2000
                                });
                            }
                        });
                    }
                });
            } else if (this.youzhicaiOrderState == 'edit') {
                this.$refs.youzhicaiOrderForm.validate((valid) => {
                    if (valid) {
                        console.log('submit');
                        post(`/youzhicai/order/edit`, { ...this.youzhicaiOrder }).then((res) => {
                            if (res.success) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000
                                });
                                this.resetYouzhicaiOrderList();
                                this.resetDialog();
                            } else {
                                this.$message({
                                    message: res.msg,
                                    type: 'error',
                                    duration: 2000
                                });
                            }
                        });
                    }
                });
            }
        },
        addYouzhicaiOrder() {
            this.showDialog = true;
            this.youzhicaiOrderState = 'add';
        },
        checkYouzhicaiOrder(youzhicaiOrderId) {
            console.log(youzhicaiOrderId);
            this.currentYouzhicaiOrderId = youzhicaiOrderId;

            this.getYouzhicaiOrderById();
            this.showDialog = true;
            this.youzhicaiOrderState = 'check';
        },
        editYouzhicaiOrder(youzhicaiOrderId) {
            console.log('youzhicaiOrder', youzhicaiOrderId);
            if (youzhicaiOrderId) {
                this.currentYouzhicaiOrderId = youzhicaiOrderId;
                this.getYouzhicaiOrderById();
            } else {
                this.youzhicaiOrder = { ...this.youzhicaiOrder, ...this.multipleSelection[0] };
            }

            this.showDialog = true;
            this.youzhicaiOrderState = 'edit';
        },
        deleteYouzhicaiOrder(youzhicaiOrderId) {
            let ids = '';
            if (youzhicaiOrderId) {
                ids = youzhicaiOrderId;
            } else {
                ids = this.multipleSelection.map((youzhicaiOrder) => youzhicaiOrder.id).join(',');
            }
            console.log({ ids });
            this.$confirm('确定删除所选项吗？', '提示', {
                type: 'warning'
            })
                .then(() => {
                    deleteFun(`/youzhicai/order/delete`, { ids }).then((res) => {
                        if (res.success) {
                            this.$message({
                                message: res.msg,
                                type: 'success',
                                duration: 2000
                            });
                            this.resetYouzhicaiOrderList();
                            this.getYouzhicaiOrderList();
                        } else {
                            this.$message({
                                message: res.msg,
                                type: 'error',
                                duration: 2000
                            });
                        }
                    });
                })
                .catch(() => {
                });
        },
        refreshYouzhicaiOrderList() {
            this.resetYouzhicaiOrderList();
            this.getYouzhicaiOrderList();
        },
        getYouzhicaiOrderList(query = {}) {
            this.loading = true;
            get(`/youzhicai/order/findList`, {
                ...this.queryForm,
                pageNum: this.currentPage,
                pageSize: this.pageSize
            }).then((res) => {
                this.loading = false;
                if (res.success) {
                    this.youzhicaiOrderList = res.page.list;
                    this.totalNum = res.page.total;
                } else {
                    this.$message({
                        message: res.msg,
                        type: 'error',
                        duration: 2000
                    });
                }
            });
        },
        getYouzhicaiOrderById() {
            get(`/youzhicai/order/get`, { id: this.currentYouzhicaiOrderId }).then((res) => {
                if (res.success) {
                    this.youzhicaiOrder = { ...this.youzhicaiOrder, ...res.youzhicaiOrder };
                } else {
                    this.$message({
                        message: res.msg,
                        type: 'error',
                        duration: 2000
                    });
                }
            });
        },
        /**
         * 导出信息
         */
        exportYouzhicaiOrderList() {
            //this.btnLoading = true;
            exprotExcel(`/youzhicai/order/export`, { ...this.queryForm });
        },
        /**
         * 导出模板
         */
        importTemplate() {
            this.btnLoading = true;
            importTemplate(`/youzhicai/order/importTemplate`, this.btnLoading);
        },
        /**
         * 导入数据
         */
        isImport() {
            this.isImportDate = !this.isImportDate;
        },
        upload(params) {
            const file = params.file;
            const formData = new FormData();
            formData.append('file', file);
            console.log({ formData });
            importDate(`/youzhicai/order/importData`, formData);
            this.refreshYouzhicaiOrderList();
        },
        handleSelectionChange(value) {
            console.log(value);
            this.multipleSelection = value;
        },
        currentChange(page) {
            this.currentPage = page;
            this.getYouzhicaiOrderList();
        },
        sizeChange(size) {
            this.pageSize = size;
            this.getYouzhicaiOrderList();
        },
        updateSrcList(src){
            this.srcList[0] = src
        },

        // 发货
        delivery(youzhicaiOrderId){
            this.currentYouzhicaiOrderId = youzhicaiOrderId;
            this.getYouzhicaiOrderById();
            this.deliveryDialog = true
        },

        // 物流信息
        freight(youzhicaiOrderId){
            this.currentYouzhicaiOrderId = youzhicaiOrderId;
            this.getYouzhicaiOrderById();
            this.freightDialog = true
        },

        // 查看快递100物流信息
        getLogistics(){
            window.open("https://www.kuaidi100.com/")
        },

        // 妥投
        orderDlok(youzhicaiOrderId){
            get("/youzhicai/order/orderDlok",{
                orderId: youzhicaiOrderId
            }).then((res)=>{
                if (res.success) {
                    this.$message({
                        message: res.msg,
                        type: 'success',
                        duration: 2000
                    });
                    this.resetYouzhicaiOrderList();
                    this.getYouzhicaiOrderList();
                } else {
                    this.$message({
                        message: res.msg,
                        type: 'error',
                        duration: 2000
                    });
                }
            })
        },

        // 获取优质采订单状态枚举
        getOrderStatusEnum() {
            get('/youzhicai/utils/getEnum', {
                enumType: 'order_status_enum'
            }).then((res) => {
                if (res.success) {
                    this.orderStatusEnumList = res.enumList;
                }
            });
        },

        // 计算优质采订单状态
        computeOrderStatus(key) {
            for (let item of this.orderStatusEnumList) {
                if (item.key == key) {
                    return item.value;
                }
            }
        }
    }

};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__header {
    border-bottom: 1px solid #eee;
}

.operation {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #409eff;
    font-size: 12px;

    & > div {
        display: flex;
        align-items: center;
        padding: 0 5px;
        cursor: pointer;
    }

    .operation-label {
        margin-left: 3px;
    }
}
</style>